export const Theme = {
  main: {
    ThemeWater: '#007B87',
  },
};

export const Brand = {
  orange: {
    Orange050: '#FEF5F0',
    Orange100: '#FEDFCD',
    Orange200: '#FDC9AB',
    Orange300: '#FAA879',
    Orange400: '#F78848',
    Orange500: '#EB5C0A',
    Orange600: '#CF4C00',
    Orange700: '#AD3F00',
    Orange800: '#893200',
    Orange900: '#512300',
  },
  iris: {
    Iris050: '#F4F1FF',
    Iris100: '#E4DBFD',
    Iris200: '#D3C7FA',
    Iris300: '#BCA7FC',
    Iris400: '#A487FF',
    Iris500: '#754AFA',
    Iris600: '#653FDA',
    Iris700: '#5A3DB2',
    Iris800: '#4F3C8A',
    Iris900: '#3E3559',
  },
  hibiscus: {
    Hibiscus050: '#FFF4F5',
    Hibiscus100: '#FFD2D7',
    Hibiscus200: '#FFB4BC',
    Hibiscus300: '#FF96A1',
    Hibiscus400: '#FA7E8B',
    Hibiscus500: '#F56675',
    Hibiscus600: '#CA4B59',
    Hibiscus700: '#9B4851',
    Hibiscus800: '#733C42',
    Hibiscus900: '#4B3033',
  },
  mustard: {
    Mustard050: '#FCF7E7',
    Mustard100: '#FCEFC4',
    Mustard200: '#FEE491',
    Mustard300: '#FFD95F',
    Mustard400: '#FFCD30',
    Mustard500: '#FFC200',
    Mustard600: '#E5AE23',
    Mustard700: '#BF952B',
    Mustard800: '#997D34',
    Mustard900: '#72612B',
  },
  water: {
    Water050: '#E6F6F7',
    Water100: '#B4E8EB',
    Water200: '#7BD3D9',
    Water300: '#41BEC6',
    Water400: '#22B0B9',
    Water500: '#00A2AB',
    Water600: '#117F84',
    Water700: '#196B70',
    Water800: '#20585B',
    Water900: '#133F42',
  },
};

export const Neutrals = {
  main: {
    Black: '#000000',
    White: '#FFFFFF',
  },
  neutralGreys: {
    GreyNatural050: '#F5F5F5',
    GreyNatural100: '#EEEEEE',
    GreyNatural150: '#E3E3E3',
    GreyNatural200: '#C4C4C4',
    GreyNatural300: '#B9B9B9',
    GreyNatural400: '#8F8F8F',
    GreyNatural500: '#666666',
    GreyNatural600: '#4E4E4E',
    GreyNatural700: '#353535',
    GreyNatural800: '#252525',
    GreyNatural850: '#1E1E1E',
    GreyNatural900: '#131313',
  },
  coldGreys: {
    GreyCold050: '#F3F7F7',
    GreyCold100: '#EBF0F0',
    GreyCold150: '#DEE5E5',
    GreyCold200: '#CDD4D4',
    GreyCold300: '#B3BABA',
    GreyCold400: '#939999',
    GreyCold500: '#717373',
    GreyCold600: '#4B4D4D',
    GreyCold700: '#373838',
    GreyCold800: '#222626',
    GreyCold850: '#1C1F1F',
    GreyCold900: '#101414',
  },
};

export const Alerts = {
  Blue100: '#F1FAFF',
  Blue500: '#105DC1',
  Blue800: '#0C4792',
  Green100: '#F3FCEF',
  Green500: '#00890B',
  Green800: '#005607',
  Yellow100: '#FFF6D9',
  Yellow500: '#FFC200',
  Yellow800: '#403100',
  Red100: '#FEEAE7',
  Red500: '#DA280C',
  Red800: '#791607',
};

export const Buttons = {
  Secondary: {
    ButtonSecondaryTextDefault: '#007b87ff',
    ButtonSecondaryStrokeDefault: '#007b87ff',
  },
};

export const Gradients = {
  AiGradient: [Brand.iris.Iris500, '#E8384B', Brand.orange.Orange500],
  BrandGradient: [Brand.iris.Iris600, Brand.water.Water500],
  AutomaticProjectGradient: [Brand.iris.Iris400, Brand.water.Water300],
  Skeleton: ['#F3F7F700', Neutrals.coldGreys.GreyCold050, Neutrals.coldGreys.GreyCold100],
  PromoGradient: [Brand.mustard.Mustard500, Brand.orange.Orange500, Brand.orange.Orange600],
  AngularGradient: ['#00a2abff', '#00a2ab'],
};
